import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
const SalesTargetForm = (props) => {
  const frmRef = useRef({});
  const [employeeData, setEmployeeData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState("");
  const [targetData, setTargetData] = useState("");
  const [isIndividual, setIsIndividual] = useState(false);

  const [data, setData] = useState();
  const {
   
    sendRequest: getTarget,
  } = useHttp();

  useEffect(() => {
    getTarget(
      {
        url: `/api/procurementTarget/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log(data);
        setTargetData(data);
      }
    );
  }, [getTarget]);

  useEffect(() => {}, [targetData]);

  const {
   
    sendRequest: getEmp,
  } = useHttp();

  const loadData = () => {
    getEmp(
      {
        url: `/api/employeeListForTargetAllocation/?useCase=Sales&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("emp11", data);
        var i = 0;
        setData(data.employeeList);

        var tempempdata = data.employeeList;

        if (props.update) {
          tempempdata = data.employeeList.filter((employee) =>
            employee.employeeName
              .toLowerCase()
              .includes(props.update.employeeName.toLowerCase())
          );

          setFilteredEmployees(props.update.employeeName);
        }
        var userTarget = data.userTarget;

        var newempList = [];
        //console.log("tempempdata", tempempdata);
        do {
          var emp = tempempdata[i];
          var tlist = userTarget.filter(
            (item) => item.procurementOfficerId == emp.empId
          );
          var tdata = tlist && tlist[0];
          newempList = newempList.concat({
            userId: tempempdata[i].userId,
            useCase: tempempdata[i].useCase,
            empId: tempempdata[i].empId,
            employeeName: tempempdata[i].employeeName,
            fromDate: tdata && tdata.fromDate,
            toDate: tdata && tdata.toDate,
            target: tdata && tdata.target,
          });
          i++;
        } while (tempempdata.length > i);

        //console.log("newempList", newempList);

        setEmployeeData(newempList);
        setFilteredEmployees(newempList);
      }
    );
  };

  useEffect(() => {
    loadData();
  }, [getEmp]);

  const handleApplyAllClick = (event) => {
    event.preventDefault();
    const targetInputValues = frmRef.current["target_set"].value;
    const fromDateValue = frmRef.current["from_date"].value;
    const toDateValue = frmRef.current["to_date"].value;
    const targetInputs = document.querySelectorAll(".target-input");

    targetInputs.forEach((targetInput, i) => {
      targetInput.value = targetInputValues;

      filteredEmployees[i].target = targetInputValues;
      filteredEmployees[i].fromDate = fromDateValue;
      filteredEmployees[i].toDate = toDateValue;

      //console.log(filteredEmployees);
      setFilteredEmployees(filteredEmployees);
    });

    var i = 0;
  };

  const handleSearchChange = (event) => {
    //console.log(event.target.value);
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const filteredEmployee = employeeData.filter((employee) =>
      employee.employeeName.toLowerCase().includes(searchQuery.toLowerCase())
    );

    //console.log(filteredEmployee);

    setFilteredEmployees(filteredEmployee);
  }, [searchQuery]);

  const {
  
    sendRequest: postTargetSet,
  } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault(false);

    const promises = filteredEmployees.map((emp) => {
      const data = {
        procurmentTargetDate: moment(
          new Date().toISOString().slice(0, 10)
        ).format("DD/MM/YYYY"),
        fromDate: moment(frmRef.current.from_date.value).format("DD/MM/YYYY"),
        toDate: moment(frmRef.current.to_date.value).format("DD/MM/YYYY"),
        procurementOfficerId: emp.empId,
        target: emp.target,
        targetId: "1",
        createdDate: moment(new Date().toISOString().slice(0, 10)).format(
          "DD/MM/YYYY"
        ),
        status: 1,
        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
        warehouseId: parseInt(localStorage.getItem("warehouseId")),
      };

      if (props.update.procurmentTargetId) {
        data["procurmentTargetId"] = props.update.procurmentTargetId;
      }

      //console.log(data);

      const existingRecord =
        targetData &&
        targetData.find((target) => target.procurementOfficerId === emp.empId);
      if (existingRecord) {
        //console.log(existingRecord);

        return Promise.all([
          postTargetSet({
            url: `/api/procurementTarget/`,
            method: "PUT",
            body: { ...existingRecord, status: 0 },
          }),
          postTargetSet({
            url: "/api/procurementTarget/",
            method: "POST",
            body: data,
          }),
        ]);
      } else {
        return postTargetSet({
          url: "/api/procurementTarget/",
          method: props.update.procurmentTargetId ? "PUT" : "POST",
          body: data,
        });
      }
    });

    Promise.all(promises)
      .then(() => {
        toast.success(`Target ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
      })
      .catch((error) => {
        toast.error(`Error: ${error.message}`);
      });
  };

  useEffect(() => {
    //console.log(props.update);

    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp11", data.output);
        const employee = data.output.find(
          (emp) => emp.empId === props.update.procurementOfficerId
        );

        if (employee) {
          //console.log("Employee name:", employee.employeeName);
          frmRef.current.emp_name.value = employee.employeeName;
          setSearchQuery(employee.employeeName);
        }
      }
    );

    if (props.update) {
      setIsIndividual(true);
      frmRef.current.target_set.value = props.update.target;
      frmRef.current.from_date.value = moment(
        props.update.fromDate,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      frmRef.current.to_date.value = moment(
        props.update.toDate,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Sales Target Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Team</label> &nbsp;
                        <input
                          type={"checkbox"}
                          id={"team"}
                          ref={(el) => (frmRef.current["team"] = el)}
                          className="checkbox"
                          disabled={props.update}
                          onChange={(event) => {
                            //frmRef.current.individual.checked=false;
                            setIsIndividual(false);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Individual</label> &nbsp;
                        <input
                          type={"checkbox"}
                          id={"individual"}
                          ref={(el) => (frmRef.current["individual"] = el)}
                          className="checkbox"
                          disabled={props.update}
                          checked={isIndividual}
                          onChange={(event) => {
                            frmRef.current.team.checked = false;
                            setIsIndividual(event.target.checked);
                            loadData();
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      {isIndividual && (
                        <div className="form-group">
                          <label>Search Procurement Officer</label>

                          <select
                            id="emp_name"
                            className="form-control"
                            ref={(el) => (frmRef.current["emp_name"] = el)}
                            onChange={handleSearchChange}
                            value={filteredEmployees}
                            disabled={props.update}
                          >
                            <option value="">Select</option>
                            {employeeData &&
                              employeeData.map((x) => (
                                <option
                                  key={x.empId}
                                  value={x.employeeName}
                                  selected={
                                    props.update &&
                                    x.empId === props.update.empId
                                  }
                                >
                                  {x.employeeName}
                                </option>
                              ))}
                          </select>
                        </div>
                      )}
                    </div>

                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>From Date</label>

                        <input
                          type={"date"}
                          id={"from_date"}
                          required
                          ref={(el) => (frmRef.current["from_date"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>To Date</label>
                        <input
                          type={"date"}
                          id={"to_date"}
                          required
                          ref={(el) => (frmRef.current["to_date"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Set Target</label>

                        <input
                          type="text"
                          className="form-control"
                          ref={(el) => (frmRef.current["target_set"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Apply All</label> <br />
                        <button
                          className="btn  btn-primary mx-2 my-2"
                          onClick={handleApplyAllClick}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Procurement Officer Name</th>
                          <th>Target </th>
                          <th>Previous From Date</th>

                          <th>Previous To Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredEmployees &&
                          filteredEmployees.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.employeeName}</td>
                                <td>
                                  <input
                                    type={"text"}
                                    required
                                    className="target-input"
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                    ref={(el) =>
                                      (frmRef.current["set_target"] = el)
                                    }
                                    value={itm.target}
                                    autoComplete="off"
                                    disabled
                                  />
                                </td>
                                <td>{itm.fromDate}</td>

                                <td>{itm.toDate}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button className="btn  btn-primary mx-2 my-2" type="submit">
                        Add
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default SalesTargetForm;
